import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import '@fontsource-variable/geist'
import './index.css'
import { useThemeStore } from '@/stores/themeStore'
import { ToastProvider } from '@/components/ui'

// Initialize theme on app load
useThemeStore.getState().initializeTheme()

// F5 — Registrar service worker (PWA) apenas em producao.
// Em dev o SW causaria cache stale e poluiria o HMR.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // eslint-disable-next-line no-console
      console.error('[pwa] failed to register service worker', err)
    })
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </StrictMode>,
)
